export default {
  // home

  // ui
  entrar: "Entra",
  play: "Riproduci",
  pause: "Pausa",
  subtitles: "Sottotitoli",
  pantalla_completa: "Schermo intero",
  salir_pantalla_completa: "Esci dalla modalità schermo intero",
  escena_completada: "Scena completata",

  // overlays

  r1_1: "A) Poupar o dinheiro que sobrar no final do mês, como tem feito até agora.",
  r1_2: "B) Aplicar o método do rapaz do Dubai: zero planeamento, zero mudanças de hábitos e resultados espetaculares.",
  r1_3: "C) Fazer contribuições periódicas: reservar um montante fixo no início de cada mês para investir, antes de começar a gastar.",

  r2_1: "A) O mesmo que nessa altura, porque o dinheiro guardado em casa não é utilizado e mantém o seu valor.",
  r2_2: "B) Menos do que nessa altura, porque os preços têm aumentado ano após ano. Perdeu poder de compra.",
  r2_3: "C) Mais do que nessa altura, porque o dinheiro guardado durante tanto tempo valoriza-se por si só.",

  r3_1: "A) Porque a tua vida mudou: casaste-te, tiveste filhos, compraste uma casa...",
  r3_2: "B) Porque os seguros de vida caducam automaticamente após algum tempo e é necessário voltar a assiná-los.",
  r3_3: "C) Porque, quanto mais anos mantiveres o mesmo seguro, mais barato a seguradora o torna.",


};